import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Loader"},[(_vm.value)?_c(VCard,{staticClass:"rounded-1 elevation-20"},[_c(VContainer,[_c(VLayout,{attrs:{"justify-center":""}},[_c(VProgressCircular,{attrs:{"color":"primary","indeterminate":"","size":100}})],1),_c(VLayout,{staticClass:"pt-4",attrs:{"justify-center":""}},[_c('h2',{staticClass:"primary--text"},[_vm._v("Loading ...")])])],1)],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }